import { C as a, e as c } from "./custom-element-BInKsiaT.js";
const o = (s, t) => {
  const e = new CustomEvent("get-tab-state", {
    bubbles: !0,
    detail: { group: t, state: {} }
  });
  return s.dispatchEvent(e), e.detail.state ?? {};
};
class u extends a {
  constructor() {
    super();
  }
  connectedCallback() {
    this.state.add("selectedTab", this.dataset.defaultTab ?? null), this.addEventListener("tab-change", (t) => {
      const { group: e, value: i, lastFocus: n } = t.detail;
      if (e === this.dataset.tabGroup)
        if (t.stopPropagation(), i === "next") {
          const r = this.querySelector(
            `tab-panel[data-tab-group="${this.dataset.tabGroup}"][aria-current=step]+tab-panel`
          );
          r ? this.state.selectedTab.set(r.dataset.item) : n && this.closest("section")?.querySelector(n)?.scrollIntoView({ behavior: "smooth", block: "center" });
        } else this.state.selectedTab.set(i);
    }), this.addEventListener("get-tab-state", (t) => {
      t.detail.group === this.dataset.tabGroup && (t.stopPropagation(), t.detail.state = this.state);
    });
  }
}
class l extends a {
  get name() {
    return this.dataset.item ?? "";
  }
  constructor() {
    super();
  }
  connectedCallback() {
    const { selectedTab: t } = o(this, this.dataset.tabGroup ?? ""), e = this.name;
    this.effects.push(
      c(() => {
        e === t.get() ? this.setAttribute("aria-current", "step") : this.removeAttribute("aria-current");
      })
    );
  }
}
class d extends a {
  constructor() {
    super();
  }
  connectedCallback() {
    this.addEventListener("click", () => {
      this.dispatchEvent(
        new CustomEvent("tab-change", {
          bubbles: !0,
          detail: {
            group: this.dataset.tabGroup,
            value: this.dataset.item,
            lastFocus: this.dataset.lastFocus
          }
        })
      );
    }), this.hasAttribute("aria-current") && this.dispatchEvent(
      new CustomEvent("tab-change", {
        bubbles: !0,
        detail: {
          group: this.dataset.tabGroup,
          value: this.dataset.item,
          lastFocus: this.dataset.lastFocus
        }
      })
    );
    const { selectedTab: t } = o(this, this.dataset.tabGroup), e = this.dataset.item;
    this.effects.push(
      c(() => {
        e === t.get() ? this.setAttribute("aria-current", "step") : this.removeAttribute("aria-current");
      })
    );
  }
}
customElements.define("tab-list", u);
customElements.define("tab-item", d);
customElements.define("tab-panel", l);
export {
  o as getTabState
};
